module.exports = __webpack_public_path__ + "static/media/catchup.897b5121.svg";